import React from 'react';
import {
  Edit,

  SimpleForm,

  DateField,
  ReferenceField,
  SelectInput,
  TextField,
  FileInput,
  UrlField,
  FileField,
} from 'react-admin';

import { docChoices } from './Create';


const Title = ({ record }) => (
  <span>Offer Document #{record.id}</span>
);


export default props => (
  <Edit
    {...props}
    title={<Title />}
    undoable={false}
  >
    <SimpleForm>
      <ReferenceField label="Offer" source="offerId" reference="offerings" linkType={false} sortable={false}>
        <TextField source="name" />
      </ReferenceField>
      <DateField source="createdAt" />
      <DateField source="updatedAt" />
      <SelectInput
        source="docType"
        choices={docChoices}
      />
      <UrlField source="url" target="_blank" />
      <FileInput source="_offerDocument" accept="application/pdf">
        <FileField source="src" title="title" />
      </FileInput>
    </SimpleForm>
  </Edit>
);



// WEBPACK FOOTER //
// ./src/components/OfferDocument/Edit.js